import React, { PureComponent } from 'react';

import { IPageResponse, SortDirection } from "../common/interfaces/IPageResponse";
import { TanksTable } from "../components/Tanks/TanksTable";
import { TanksSearchBar } from "../components/Tanks/TanksSearchBar";
import { ISortedPageRequest } from 'common/interfaces/IPageRequest';
import { ITank, ITanksSortFields } from 'models/tanks';
import TanksService from 'services/tanks.service';
import { AuthenticationContext } from 'services/context/authentication.context';

export interface ITanksState {
  tanks: IPageResponse<ITank> | null;
  pageRequest: ISortedPageRequest<ITanksSortFields>;
  customerId: number | null;
  contactId: number | null;
}

class Tanks extends PureComponent<any, ITanksState> {
  static contextType = AuthenticationContext;

  constructor(props: any) {
    super(props);
    this.state = {
      tanks: null,
      customerId: null,
      contactId: null,
      pageRequest: {
        page: 0,
        size: 25,
        sortDirection: SortDirection.ASC,
        sortField: ITanksSortFields.ID
      }
    };
    this.props.onLoadValidatePage();
  }

  getTanks = () => {
    TanksService.getAllTanks(this.context.state.customerId, this.state.pageRequest).then((response: IPageResponse<ITank>) => {
      this.setState({
        tanks: response
      });
    });
  };
  onPageChange = (targetPage: number) => {
    if (this.state.pageRequest.page + 1 !== targetPage) {
      this.setState({
        pageRequest: {
          ...this.state.pageRequest,
          page: targetPage - 1
        }
      }, () => this.getTanks());
    }
  };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId ||
            (this.context.state.customer && this.context.state.customer.contactId !== this.state.contactId)
        ) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
                contactId: (this.context.state.customer && this.context.state.customer.contactId) || this.state.contactId,
                pageRequest: {
                    ...this.state.pageRequest,
                    page: 0
                }
            }, () => {
                this.getTanks();
            });
        }
    };

  componentDidMount(): void {
    this.updateCustomerId();
  }

  componentDidUpdate(): void {
    this.updateCustomerId();
  }

  render() {
    return (
      <div className="document-rows__container">
        <TanksSearchBar />
        {this.state.tanks !== null ?
          <TanksTable tanks={this.state.tanks}
            onPageChange={this.onPageChange}
          /> :
          null
        }

      </div>
    );
  }
}



export default Tanks;